import MockAdapter from 'axios-mock-adapter';
import axios from 'axios';

let mock;

const initMock = () => {
  mock = new MockAdapter(axios, { delayResponse: 800 });
};

const getMockAdapter = () => {
  return mock;
};

/**
 * to call the original API if the mock function is not set
 */
const passThroughOtherCalls = () => {
  if (mock) {
    mock.onAny().passThrough();
  }
};

export { initMock, getMockAdapter, passThroughOtherCalls };



// WEBPACK FOOTER //
// ./src/mock/mock.js